'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EditorHighlight = function EditorHighlight(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z' })
  );
};
EditorHighlight = (0, _pure2.default)(EditorHighlight);
EditorHighlight.displayName = 'EditorHighlight';

exports.default = EditorHighlight;


/*****************
 ** WEBPACK FOOTER
 ** ./~/material-ui/svg-icons/editor/highlight.js
 ** module id = 1454
 ** module chunks = 0
 **/